<div class="location-prefernces">
    <input type="checkbox" [checked]="check" (change)="checkboxClick($event)"
     class="custom-control-input location-external-pref" [id]="checkboxName">
    <label class="custom-control-label pa-label pa-label-external" [for]="checkboxName">&nbsp;</label>
</div>
